var index = 0;
export var generateID = function () {
    return (index += 1);
};
//# sourceMappingURL=uid.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mapbox-gl/lib-esm/util/uid.js
// module id = 191
// module chunks = 1